import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userState: {},
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setState(state, action) {
      state.userState = action.payload;
    },
  },
});

export const { setState } = userSlice.actions;
export default userSlice.reducer;
